/**
 * data-export-status-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_STATUS_DATA_EXPORT)
export class DataExportStatusResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_STATUS_DATA_EXPORT;

  @validateOpaqueID()
  public exportId : number;

  @validateAs("integer")
  public processed : number;

  @validateAs("integer")
  public rejected : number;

  @validateAs("integer")
  public viable : number;

  /**
   * The number of records in the export so far (may diverge from processed due
   * to summarization flattening)
   */
  @validateAs("integer")
  public recordCount : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/data-export-status-response.ts